/* src/app/components/pages/shippingaddress/shippingaddress.component.scss */
#mainContent {
  background-color: #EBEBEB;
  max-width: 1365px;
  margin: auto;
}
@media only screen and (min-width: 1200px) {
  #mainContent {
    padding: 50px;
  }
}
#mainContent {
  padding: 16px;
}
#mainContent .main .borderLeft {
  border-left: 1px solid #cfcfcf;
  height: auto;
}
#mainContent .main .borderBottom {
  border-bottom: 1px solid #cfcfcf;
}
#mainContent .main .color-f-s-23 {
  font-size: 23px;
  color: #5e5e5e;
}
#mainContent .main .footerBottom .mat-mdc-button {
  background-color: var(--theme-deafult-secondary);
  font-size: 14px;
  color: #ffffff;
  margin: 6px 8px;
  padding: 0px 14px;
  cursor: pointer;
  min-height: 36px;
  min-width: 88px;
  border-radius: 23px;
}
#mainContent .main .viewAddress {
  margin-bottom: 18px;
  font-style: normal;
  line-height: 1.42857143;
}
@media only screen and (max-width: 600px) {
  #mainContent .main .m-top-50 {
    margin-top: 50px;
  }
}
.p-8 {
  padding: 8px;
}
.color-f-s-14 {
  color: #5e5e5e;
  font-size: 14px;
}
::ng-deep .mat-mdc-button {
  font-family: "IBM Plex Sans", sans-serif !important;
}
/*# sourceMappingURL=shippingaddress.component.css.map */
